import { api } from '../../../../AxiosConfig';

export type PageNameCheck = {
    available: boolean;
    pageName: string;
    reason?: 'invalid' | 'taken';
    message?: string;
};

export type PaginaPayload = {
    pageName: string;
    active: boolean;
    imagesIds: string[];
    title: string;
    description: string;
    about: string;
    aboutImageId: string;
    highlights: { icon: string; title: string; text: string }[];
    testimonials: { name: string; text: string }[];
    imagesIdsHeader?: string[];
};

class PaginaService {
    findByEstab() {
        return api.get('/landing-pages/findByEstab');
    }

    checkPageName(pageName: string) {
        return api.get<PageNameCheck>('/landing-pages/check-page-name', { params: { pageName } });
    }

    create(data: PaginaPayload & { templateId: string }) {
        return api.post('/landing-pages/create', data);
    }

    update(data: PaginaPayload) {
        return api.post('/landing-pages/update', data);
    }
}

export { PaginaService };
